import {Stack} from "@mui/material";
import React, {useState} from "react";
import {ActivityFilterDto} from "../../../../common/apis/activity/ActivityFilterDto";
import DataGridContainer from "../../../../components/grid/DataGridContainer";
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import {t} from "../../../../store/localization/TranslMessasge";
import ActivitiesFilter from "./ActivitiesFilter";
import ActivitiesGrid from "./ActivitiesGrid";
import {ActivityGridColDefFactory} from "./ActivityGridColDefFactory";
import {ActivityTranslationKey} from "./ActivityTranslationKey";


export default function ActivitiesPage() {
    const [filter, setFilter] = useState<ActivityFilterDto>({validFrom: null, validThru: null});

    return (
        <Page>
            <PageHeader>
                <PageTitle title={t(ActivityTranslationKey.ACTIVITY_TITLE)}/>
            </PageHeader>
            <PageContent>
                <Stack spacing={2}>
                    <ActivitiesFilter onFilterChange={setFilter}/>
                    <DataGridContainer>
                        <ActivitiesGrid
                                filter={filter}
                                columns={ActivityGridColDefFactory.buildForAdministration()}/>
                    </DataGridContainer>
                </Stack>
            </PageContent>
        </Page>
    );
}
